import { render } from "./header-update.vue?vue&type=template&id=1ffb8b36&scoped=true&ts=true"
import script from "./header-update.vue?vue&type=script&lang=ts"
export * from "./header-update.vue?vue&type=script&lang=ts"

import "./header-update.vue?vue&type=style&index=0&id=1ffb8b36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffb8b36"]])

export default __exports__